__turbopack_context__.v({
  "card": "styles-module-scss-module__UsWqZa__card",
  "property_image": "styles-module-scss-module__UsWqZa__property_image",
});
